export default __webpack_public_path__ + "static/media/drone16.21155c5f.webp";